module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/variable");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("@tencent/iwan-login");

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enablePhoneLogin */
/* unused harmony export disablePhoneLogin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isHidePhoneLogin; });
if (typeof window.isHidePhoneLoginValue === 'undefined') {
  window.isHidePhoneLoginValue = true;
}

/**
 * 允许手机号登录选项
 */
var enablePhoneLogin = function enablePhoneLogin() {
  window.isHidePhoneLoginValue = false;
};

/**
 * 禁止手机号登录选项
 */
var disablePhoneLogin = function disablePhoneLogin() {
  window.isHidePhoneLoginValue = true;
};
var isHidePhoneLogin = function isHidePhoneLogin() {
  return window.isHidePhoneLoginValue;
};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/bridge");

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/user-client");

/***/ }),
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleLoginType; });
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__);


// 判断登录账户登录态类型, 并返回登录态类型
var handleLoginType = function handleLoginType(type) {
  var loginType = '';
  if (!type) {
    return loginType;
  }
  if ([_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__["LoginType"].qq, 'qq'].includes(type)) {
    loginType = 'qq';
  } else if ([_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_0__["LoginType"].wx, 'wx', 'weixin'].includes(type)) {
    loginType = 'wx';
  }
  ;
  return loginType;
};

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/iwan-cgi");

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainUserInfo", function() { return mainUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "payVipInfo", function() { return payVipInfo; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _tencent_txv_athena_bridge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14);
/* harmony import */ var _tencent_txv_athena_bridge__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_bridge__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _tencent_txv_athena_api_statistics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23);
/* harmony import */ var _tencent_txv_athena_api_statistics__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_api_statistics__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17);
/* harmony import */ var _tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5);
/* harmony import */ var _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11);



function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }









var mainUserInfo = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
    var _yield$iwanLogin$getU, errCode, errMsg, result, _yield$iwanLogin$getL, loginInfo, type;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9___default.a.isHidePhoneLogin = Object(_config__WEBPACK_IMPORTED_MODULE_11__[/* isHidePhoneLogin */ "a"])();
          _context.next = 3;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9___default.a.getUserInfo();
        case 3:
          _yield$iwanLogin$getU = _context.sent;
          errCode = _yield$iwanLogin$getU.errCode;
          errMsg = _yield$iwanLogin$getU.errMsg;
          result = _yield$iwanLogin$getU.result;
          if (!(errCode === -1)) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", {
            code: errCode,
            msg: errMsg,
            result: {
              type: '',
              nickname: '',
              headImgUrl: ''
            }
          });
        case 9:
          _context.next = 11;
          return _tencent_iwan_login__WEBPACK_IMPORTED_MODULE_9___default.a.getLoginInfo();
        case 11:
          _yield$iwanLogin$getL = _context.sent;
          loginInfo = _yield$iwanLogin$getL.result;
          type = Object(_common__WEBPACK_IMPORTED_MODULE_10__[/* handleLoginType */ "a"])(loginInfo && loginInfo.type);
          return _context.abrupt("return", {
            code: errCode,
            msg: errMsg,
            result: {
              type: type,
              nickname: result && result.nickname,
              headImgUrl: Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["convertProtocol"])(result && result.avatar)
            }
          });
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function mainUserInfo() {
    return _ref.apply(this, arguments);
  };
}();
var payVipInfo = /*#__PURE__*/function () {
  var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()(/*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2() {
    var retData, _yield$to, _yield$to2, err, _yield$to2$, res, code, msg, data, vipLevel, _yield$bridge$getPayV, errCode, errMsg, _yield$bridge$getPayV2, result, vip, level;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          retData = {
            code: 0,
            msg: '',
            result: {
              vip: 0,
              level: 0
            }
          };
          if (Object(_tencent_txv_athena_core_user_client__WEBPACK_IMPORTED_MODULE_8__["isLogin"])()) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return", retData);
        case 3:
          if (_tencent_txv_athena_bridge__WEBPACK_IMPORTED_MODULE_6___default.a.getPayVip) {
            _context2.next = 18;
            break;
          }
          _context2.next = 6;
          return Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_4__["to"])(_tencent_txv_athena_api_statistics__WEBPACK_IMPORTED_MODULE_7___default.a.getVipLevel());
        case 6:
          _yield$to = _context2.sent;
          _yield$to2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_yield$to, 2);
          err = _yield$to2[0];
          _yield$to2$ = _yield$to2[1];
          res = _yield$to2$ === void 0 ? {} : _yield$to2$;
          code = res.code, msg = res.msg, data = res.data; // 接口方法出错 未返回情况
          if (!err) {
            _context2.next = 16;
            break;
          }
          retData.code = -1;
          retData.msg = 'Server GetVipLevel Throw Error';
          return _context2.abrupt("return", retData);
        case 16:
          if (_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_5__["CODES_SUCCESS"].codes.includes(code)) {
            vipLevel = Number(data);
            retData.result = _objectSpread(_objectSpread({}, retData.result), {}, {
              vip: vipLevel && 1,
              level: vipLevel
            });
          } else {
            // 接口有返回但提供错误码情况
            retData.code = code;
            retData.msg = msg;
          }
          return _context2.abrupt("return", retData);
        case 18:
          _context2.next = 20;
          return _tencent_txv_athena_bridge__WEBPACK_IMPORTED_MODULE_6___default.a.getPayVip();
        case 20:
          _yield$bridge$getPayV = _context2.sent;
          errCode = _yield$bridge$getPayV.errCode;
          errMsg = _yield$bridge$getPayV.errMsg;
          _yield$bridge$getPayV2 = _yield$bridge$getPayV.result;
          result = _yield$bridge$getPayV2 === void 0 ? {} : _yield$bridge$getPayV2;
          vip = result.vip, level = result.level;
          return _context2.abrupt("return", {
            code: errCode,
            msg: errMsg,
            result: {
              vip: vip,
              level: level
            }
          });
        case 27:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function payVipInfo() {
    return _ref2.apply(this, arguments);
  };
}();

/***/ })
/******/ ]);